import { Injectable } from '@angular/core';
import { Validators, ValidatorFn, AsyncValidatorFn } from "@angular/forms"
import * as customFormValidators from '@common/validators/custom-form-validators';
import { FormFieldValidator } from "../models/dynamic-form.interfaces"

@Injectable({
  providedIn: 'root',
})
export class DynamicFormValidatorMapperService {
  constructor() { }

  mapValidators(validators) {
    const formValidators: Array<ValidatorFn> = [];

    if (validators) {
        validators.forEach((validator: FormFieldValidator) => {
          if ( validator.explicitValidator ){
            formValidators.push(validator.explicitValidator);
          }
          else {
            switch (validator.key) {
              case 'required':
                formValidators.push(Validators.required);
                break;
              case 'maxlength':
                  formValidators.push(Validators.maxLength(validator.value));
                  break;
                case 'validateFilter':
                  formValidators.push(customFormValidators.validateFilter);
                  break;
              }    
          }
        });
      }

    return formValidators;
  }

  mapAsyncValidators(validators) {
    //Currently returning empty array, will need to be updated when async validaors are implemented for dynamic forms
    const formValidators: Array<AsyncValidatorFn> = [];
    return formValidators;
  }
}
